module.exports = __webpack_public_path__ + "img/download-icon.153aa219.svg";